import { Theme, css } from '@emotion/react'

export const formEl = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-style: italic;
`

export const submitButton = css`
  font-style: inherit;
`

export const error = (theme: Theme) => css`
  color: ${theme.colors.red};
  text-align: left;
`
